<script setup>
import BroadcastTemplateForm from '@/components/crm/BroadcastTemplateForm.vue'
import { useApi } from '@/utils/api'
import { useApiRequest } from '@/composables/useApiRequest'

definePage({
  meta: {
    layout: 'default',
    action: 'update',
    subject: 'Broadcast',
  },
})

const route = useRoute()
const router = useRouter()
const { loading, errors, request } = useApiRequest()

const form = ref({
  name: '',
  channel: 'whatsapp',
  subject: '',
  body_template: '',
  type: 'custom',
  is_active: true,
})

const fetchLoading = ref(true)
const fetchError = ref('')

onMounted(async () => {
  try {
    const response = await useApi(`/api/v1/broadcast-templates/${route.params.id}`).get()
    const body = response?.data ?? response
    const t = body?.data ?? body

    form.value = {
      name: t.name ?? '',
      channel: t.channel ?? 'whatsapp',
      subject: t.subject ?? '',
      body_template: t.body_template ?? '',
      type: t.type ?? 'custom',
      is_active: t.is_active ?? true,
    }
  } catch (err) {
    fetchError.value = 'Gagal memuat data template.'
    console.error('[BroadcastTemplateEdit] fetch error', err)
  } finally {
    fetchLoading.value = false
  }
})

const submit = async () => {
  const result = await request(() =>
    useApi(`/api/v1/broadcast-templates/${route.params.id}`).put({ body: form.value }),
  )

  if (result !== null) {
    router.push({ name: 'crm-broadcast-templates' })
  }
}
</script>

<template>
  <VRow>
    <VCol cols="12">
      <VCard>
        <VCardTitle class="pt-5 px-5">
          Edit Template Broadcast
        </VCardTitle>

        <VDivider />

        <VCardText
          v-if="fetchLoading"
          class="pa-10 text-center"
        >
          <VProgressCircular
            indeterminate
            color="primary"
          />
        </VCardText>

        <VCardText
          v-else-if="fetchError"
          class="pa-5"
        >
          <VAlert type="error">
            {{ fetchError }}
          </VAlert>
        </VCardText>

        <VCardText
          v-else
          class="pa-5"
        >
          <VAlert
            v-if="errors._general"
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ errors._general[0] }}
          </VAlert>

          <BroadcastTemplateForm
            v-model="form"
            :errors="errors"
          />
        </VCardText>

        <VDivider />

        <VCardActions class="pa-5">
          <VSpacer />
          <VBtn
            variant="tonal"
            :to="{ name: 'crm-broadcast-templates' }"
          >
            Batal
          </VBtn>
          <VBtn
            color="primary"
            :loading="loading"
            :disabled="fetchLoading || !!fetchError"
            @click="submit"
          >
            Simpan Perubahan
          </VBtn>
        </VCardActions>
      </VCard>
    </VCol>
  </VRow>
</template>
